import {Routes} from '@src/Constant/routes';
import {pathToRegexp} from 'path-to-regexp';

const drawerRoutes: string[] = [
  Routes.PROFILE_HOME,
  Routes.PROFILE_MY_PROFILE,
  Routes.PROFILE_SUBSCRIPTION,
  Routes.PROFILE_SETTINGS,
  Routes.PROFILE_LEGAL_INFORMATION,
  Routes.PROFILE_HELPDESK,
  Routes.PROFILE_ZENDESK_FORM,
  Routes.MORE,
  Routes.PROMOCODE,
  Routes.PROFILE_SESSIONS,
];

export const isDrawerRoute = (path: string): boolean => {
  if (!drawerRoutes.length) {
    return false;
  }
  const drawerRouteRegex = pathToRegexp(drawerRoutes, []);
  return drawerRouteRegex.test(path);
};
